import React, { Fragment, useEffect } from "react";
import { IC } from "../../../../resources/Assets";

export default (props) => {

    // const imageStyle = {display:"block", maxWidth:"100%", height:"auto", width:"200px"};
    const imageStyle = {display:"inline-block", width:"200px"};
    const arrowLeftStyle = {display: props.pageIdx > 1 ? "block" : "none", maxWidth:"100%", height:"auto", width:"24px", position:"absolute", left:"20px"};
    const arrowRightStyle = {display: props.pageIdx < 7 ? "block" : "none", maxWidth:"100%", height:"auto", width:"24px", position:"absolute", right:"20px"};
    const slideDivStyle = {maxWidth:"100%", textAlign:"center"}

    useEffect(() => {
        $(".bt-slide").slick({
            arrows: true
            , pauseOnFocus: false
            , slideToShow: 1
            , infinite: false

            // , prevArrow : "<button type='button' class='slick-prev' onClick=" + ()=>props.minusPageIdx() + ">Previous</button>"		// 이전 화살표 모양 설정
			// , nextArrow : "<button type='button' class='slick-next'>Next</button>"		// 다음 화살표 모양 설정
        });

        // function(event, slick, currentSlide, nextSlide)
        $(".bt-slide").on("afterChange", function(e, s, activeSlideIdx) {
            props.setPageIdx(parseInt(activeSlideIdx)+1);
        });
    }, []);

    return(
        <Fragment>
            <div>
                <h3 style={{color:"#9D60F4"}}>
                    {props.pageIdx < 6 
                        ? "1Step. GluNEO® 블루투스 연결" 
                        : "2Step. GluNEO® 자동입력 설정"
                    }
                </h3>
                <p style={{color:"#A0A0A0"}}>
                    {props.pageIdx < 6 
                        ? "-로그인된 케어포미 앱과 GluNEO® 를 준비해주십시요" 
                        : "-기기에서 On Auto Send 설정해주십시요"
                    }
                    
                </p>
            </div>

            <div style={{paddingTop:"12vh"}}>
                {/* <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}> */}
                <div>
                        {/* <div><img src={IC.etc.ARROW_LEFT_GREY} style={arrowLeftStyle} onClick={()=>props.minusPageIdx()} /></div> */}
                        <div>
                            <div className="bt-slide">
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP1} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP2} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP3} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP3} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP3} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP4} style={imageStyle} /></div>
                                <div style={slideDivStyle}> <img src={IC.gluneo.STEP5} style={imageStyle} /></div>
                                
                                
                                {/* {props.pageIdx === 1 && <img src={IC.gluneo.STEP1} style={imageStyle} />}
                                {props.pageIdx === 2 && <img src={IC.gluneo.STEP2} style={imageStyle} />}
                                {(props.pageIdx === 3 || props.pageIdx === 4 || props.pageIdx === 5) && <img src={IC.gluneo.STEP3} style={imageStyle} />}
                                {props.pageIdx === 6 && <img src={IC.gluneo.STEP4} style={imageStyle} />}
                                {props.pageIdx === 7 && <img src={IC.gluneo.STEP5} style={imageStyle} />} */}
                            </div>
                        </div>
                        
                        {/* <div><img src={IC.etc.ARROW_RIGHT_GREY} style={arrowRightStyle} onClick={()=>props.plusPageIdx()} /></div> */}
                </div>
            </div>

            {
                props.pageIdx === 3
                    && <ArrowDownGif />
            }
            {/* <ToastMessage slideIndex={(props.pageIdx-1)} /> */}
        </Fragment>
    )
}

const ArrowDownGif = () => {
    const ArrowDivStyle = {display:"flex", justifyContent:"center"};
    const ArrowStyle = {width:"40px", bottom:"58px", position:"absolute"};
    return(
        <div style={ArrowDivStyle}>
            <img src={IC.gluneo.ARROW} style={ArrowStyle} />
        </div>
    )
}